module.exports = __webpack_public_path__ + "static/media/kwik-comfort-simp-logo.829b48ed.png";